
import axios from 'axios';
var _API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGV2ZWxvcG1lbnQgdG9rZW4iLCJwbGF0Zm9ybSI6ImRldiIsImFwcCI6IkRldmVsb3BtZW50In0.QXkohQ7lHeuS71xdcQJWa9_krUjtxFI4s1BqF1FkvW0';

const getStations = (context) => {

    context.commit('SET_WS_LOADING', true);

    axios
        .get('https://api.agroclimate.org/v2/ws/stations', {
                headers: { 
                    'x-api-key': _API_KEY,
                    'Authorization': 'Bearer ' + sessionStorage.getItem('user-jwt')
                }
            }
        )
        .then(response => {
            if (response.data.code == 'SUCCESS')
                context.commit('SET_STATION', response.data.data);
            context.commit('SET_WS_LOADING', false);
        })
        .catch(e => {
            console.log(e);
        });
};

const setVirtualWeatherStation = (context, station) => {
    var newVws = {
        "station": {
            "name" : station.name, 
            "pvt": true, 
            "loc" : {
                "lat" : station.latitude, 
                "lon" : station.longitude
            },
            "itl": 60,
            "src": {
                "name": "acis",
                "rsid": "acis",
                "sens": [{
                    "rmt": {
                        "id": "prcp",
                        "unit": "in"
                    },
                    "lcl": {
                        "id": "totR",
                        "unit": "mm"
                    }
                }, {
                    "rmt": {
                        "id": "temp",
                        "unit": "f"
                    },
                    "lcl": {
                        "id": "avgT",
                        "unit": "c"
                    }
                }, {
                    "rmt": {
                        "id": "rhum",
                        "unit": "percent"
                    },
                    "lcl": {
                        "id": "avgH",
                        "unit": "percent"
                    }
                }, {
                    "rmt": {
                        "id": "dwpt",
                        "unit": "f"
                    },
                    "lcl": {
                        "id": "avgDP",
                        "unit": "c"
                    }
                }, {
                    "rmt": {
                        "id": "lwt",
                        "unit": "min"
                    },
                    "lcl": {
                        "id": "lwd.s1",
                        "unit": "number"
                    }
                }, {
                    "rmt": {
                        "id": "wspd",
                        "unit": "m_sec"
                    },
                    "lcl": {
                        "id": "winS",
                        "unit": "m_sec"
                    }
                }, {
                    "rmt": {
                        "id": "wdir",
                        "unit": "degree"
                    },
                    "lcl": {
                        "id": "winD",
                        "unit": "degree"
                    }
                }, {
                    "rmt": {
                        "id": "srad",
                        "unit": "w_m2"
                    },
                    "lcl": {
                        "id": "solR",
                        "unit": "w_m2"
                    }
                }]
            }
        }
    };

    context.commit('SET_WS_CREATING', {status: true, data: {}});
    axios({
        method: 'post',
        url: 'https://api.agroclimate.org/v2/ws/virtualstation',
        headers: { 
            'x-api-key': _API_KEY,
            'Authorization': 'Bearer ' + sessionStorage.getItem('user-jwt')
        },
        data: newVws
      }).then(response => {
        context.commit('SET_WS_CREATING', { status: false, data: response.data });
        console.log('onCreate vws: ', response)
    })
    .catch(e => {
        context.commit('SET_WS_CREATING', { status: false,  data: {code: 'ERROR', message: ''}});
        console.log(e);
    });

    // context.commit('SET_STATION', station);
};

const setStations = (context, stations) => {
    context.commit('SET_STATION', stations);
};

const setWsLayerStatus = (context, status) => {
    context.commit('SET_VIEW_WS_LAYER', status);
};

const setViewWeatherStationManager = (context, status) => {
    context.commit('SET_VIEW_WEATHER_STATION_MANAGER', status)
}

const resetWsCreating = (context) => {
    context.commit('SET_WS_CREATING', { status: false,  data: {}});
}

export default {
    getStations,
    setStations,
    setWsLayerStatus,
    setVirtualWeatherStation,
    setViewWeatherStationManager,
    resetWsCreating,
    
    // Delete a virtual weather station by id
    deleteVirtualWeatherStation: (context, stationId) => {
        if (!stationId) return;
        context.commit('SET_WS_DELETING', { id: stationId, status: true });
        axios({
            method: 'delete',
            url: `https://api.agroclimate.org/v2/ws/virtualstation/${stationId}`,
            headers: {
                'x-api-key': _API_KEY,
                'Authorization': 'Bearer ' + sessionStorage.getItem('user-jwt')
            }
    }).then(() => {
            // optimistic remove on success
            context.commit('REMOVE_STATION', stationId);
            // show alert via root action
            context.dispatch('setAlert', { message: 'Virtual Weather Station deleted.', type: 'success' }, { root: true });
        }).catch(err => {
            console.log('Error deleting station', err);
            context.dispatch('setAlert', { message: 'Failed to delete station. Please try again.', type: 'error' }, { root: true });
            context.commit('SET_WS_DELETING', { id: stationId, status: false });
        });
    }
};